import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { fileUrl } from "./HeroSlides";

// Loop a banner video between trim.start and trim.end seconds.
export function LoopVideo({ src, trim, className, ...rest }) {
  const ref = useRef(null);
  const start = trim?.start || 0;
  const end = trim?.end;
  return (
    <video ref={ref} src={src} className={className} autoPlay muted playsInline loop={!end} {...rest}
      onLoadedMetadata={() => { if (start) ref.current.currentTime = start; }}
      onTimeUpdate={() => { const v = ref.current; if (end && (v.currentTime >= end || v.currentTime < start - 0.5)) { v.currentTime = start; v.play().catch(() => {}); } }}
      onEnded={() => { if (end) { ref.current.currentTime = start; ref.current.play().catch(() => {}); } }} />
  );
}

export function TrimEditor({ slide, onSaved }) {
  const [dur, setDur] = useState(0);
  const [t, setT] = useState(slide.trim || { start: 0, end: 0 });
  const [saving, setSaving] = useState(false);
  const end = t.end || Math.min(dur, 10);
  const len = Math.round((end - t.start) * 10) / 10;
  const ok = len >= 2 && len <= 30;
  async function save() {
    setSaving(true);
    try { const { data } = await api.put(`/weddings/mine/banner/${slide.slide_id}/trim`, { start: t.start, end }); onSaved(data); toast.success("Loop saved"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setSaving(false); }
  }
  const range = (key, val, min) => (
    <label className="block text-xs"><span className="text-[var(--muted)]">{key === "start" ? "Start" : "End"}: {val.toFixed(1)}s</span>
      <input type="range" min={min} max={dur || 1} step="0.1" value={val} onChange={(e) => setT({ ...t, start: t.start, end, [key]: parseFloat(e.target.value) })} className="w-full accent-[var(--gold)]" data-testid={`trim-${key}`} />
    </label>
  );
  return (
    <div className="space-y-3" data-testid="trim-editor">
      <p className="text-xs text-[var(--muted)]">Pick the few seconds that loop in your banner (2 to 30 seconds).</p>
      <LoopVideo src={fileUrl(slide.path)} trim={{ start: t.start, end }} className="w-full max-w-md aspect-video object-cover rounded-lg bg-black"
        onLoadedMetadataCapture={(e) => { setDur(e.currentTarget.duration || 0); if (!slide.trim) setT({ start: 0, end: Math.min(e.currentTarget.duration || 0, 10) }); }} data-testid="trim-preview" />
      {dur > 0 && <>
        {range("start", t.start, 0)}
        {range("end", end, 0)}
        <div className="flex items-center gap-3">
          <span className={`text-xs ${ok ? "text-[var(--muted)]" : "text-red-600"}`} data-testid="trim-length">Loop length: {len}s</span>
          <button onClick={save} disabled={!ok || saving} className="btn-gold text-xs" data-testid="trim-save">Save loop</button>
        </div>
      </>}
    </div>
  );
}
